import React, {useState} from "react";
import {LinearProgressBar} from "../progress-bar/LinearProgressBar";
import DeleteButton from "../buttons/DeleteButton";
import {calculateDifferenceDeadlineAndNoW, getDateInFrench} from "../../utils/dateUtils";
import EditButton from "../buttons/EditButton";
import accountSVG from "../../images/account.svg";
import actionSVG from '../../images/nav/actions.svg'
import OKR_target from "../../images/OKR/OKR_target.svg"
import styled from "styled-components";
import {DisplayForHead} from "../../permissions/DisplayAccordingToRole";
import {useDispatch, useSelector} from "react-redux";
import {deleteOneAction, getOneAction, loadActions} from "./actionAction";
import ActionModal from "../modal/action/ActionModal";
import YesNoModal from "../modal/YesNoModal";
import {loadProject} from "../project/one-project/projectAction";
import SubTagPlentyCard from "../tag/subTag/SubTagPlentyCard";
import {getImage, sliceText} from "../../utils/utils";
import projectIMG from "../../images/nav/rocket.svg";
import {loadAllObjectives} from "../objective/ObjectiveActions";
import ActionOkrModal from "../modal/action/ActionOkrModal";


const ActionCard = ({
                        pilot,
                        name,
                        criticality,
                        deadline,
                        advancement,
                        actionId,
                        projectId = 0,
                        inActionPage,
                        completedDate,
                        creationDate,
                        tags,
                        projectName,
                        keyResultId,
                        keyResultTitle,
                        fromOkrs,
                        fromCascade,
                        fromProject
                    }) => {

    const dispatch = useDispatch()
    const [isOpenModal, setOpenModal] = useState(false)
    const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false)
    const {status: currentUserStatus} = useSelector(state => state.currentUser)
    const project = useSelector(state => state.project)
    const currentUser = useSelector(state => state.currentUser)

    const updateAction = async (actionId) => {
        if (currentUserStatus === 200) {
            if (actionId !== 0) {
                await dispatch(getOneAction(actionId))
                setOpenModal(true)
            }
        }
    }


    const deleteRequest = async (action_id) => {
        if (currentUserStatus === 200) {
            await dispatch(deleteOneAction(action_id));
            await dispatch(loadAllObjectives(currentUser.id))

            setIsOpenDeleteModal(false);
            if (projectId !== 0) {
                await dispatch(loadProject(project.id))
            } else {
                await dispatch(loadActions(currentUser.id))
            }
        }
    }

    const displayModal = () => {
        if (isOpenModal) {
            if(project.id !== 0){
                return (
                    <ActionModal
                        setOpenModal={setOpenModal}
                        selectedActionId={actionId}
                        inActionPage={inActionPage}
                    />
                )
            }
            else{
                return (
                    <ActionOkrModal
                        setOpenModal={setOpenModal}
                        selectedActionId={actionId}
                        inActionPage={inActionPage}
                    />
                )
            }
        } else if (isOpenDeleteModal) {
            return (
                <YesNoModal
                    name={"cette action ? "}
                    setOpenModal={setIsOpenDeleteModal}
                    handleClickYesAction={deleteRequest}
                    id={actionId}
                />
            )
        }
    }

    const displayCriticality = (criticality) => {
        switch (criticality) {
            case 0:
                return (
                    <ContainerCriticality>
                        <div className="dots green-dots "/>
                        <p className="fw-500 fs-09"> Faible </p>
                    </ContainerCriticality>
                );
            case 1:
                return (
                    <ContainerCriticality>
                        <div className="dots yellow-dots "/>
                        <p className="fw-500 fs-09"> Modérée </p>
                    </ContainerCriticality>
                );
            case 2:
                return (
                    <ContainerCriticality>
                        <div className="dots red-dots "/>
                        <p className="fw-500 fs-09"> Élevée </p>
                    </ContainerCriticality>
                );
            default:
                return <h5> Pas de criticité définie </h5>
        }
    }


    const displayDate = () => {
        if (advancement === 100) {
            if (completedDate !== null) {
                return (
                    <div>
                        <p> Mise à jour le : </p>
                        <p> {getDateInFrench(completedDate)}</p>
                    </div>
                )
            } else {
                return (
                    <div>
                        <p> Mise à jour le : </p>
                        <p> {getDateInFrench(creationDate)}</p>
                    </div>
                )
            }
        } else {
            return (
                <p> {getDateInFrench(deadline)} {calculateDifferenceDeadlineAndNoW(deadline)}</p>
            )
        }
    }


    return (
        <Container>
            {displayModal()}
            <Card>

                <TopSection>
                    {
                        inActionPage &&
                        <>
                            {
                                projectName ?
                                    <MiddleSection>
                                        <img src={projectIMG} alt="tous les projets de l'entreprise"/>
                                        <p> {sliceText(projectName, 50)}</p>
                                    </MiddleSection>
                                    :
                                    <MiddleSection>
                                        <img src={OKR_target} alt="OKRs"/>
                                        <p> {sliceText(keyResultTitle, 50)}</p>
                                    </MiddleSection>
                            }
                            <TitleActionPage>
                                <p> {name}</p>
                            </TitleActionPage>
                        </>
                    }
                </TopSection>
                {
                    !inActionPage &&
                    <Title>
                        <p> {name}</p>
                    </Title>
                }
                <DIV>
                    {
                        !inActionPage &&
                        <Icon>
                            <img src={actionSVG} alt="action icon"/>
                        </Icon>

                    }
                    <Pilot>
                        <img className={'icon-pilot'}
                             src={getImage(pilot.photo, accountSVG)}
                             alt="pilote"
                        />
                        <p> {pilot.firstName === "Deleted" ? "Utilisateur supprimé" : pilot.firstName} {pilot.lastName === "User" ? "" : pilot.lastName} </p>
                    </Pilot>

                    <ContainerInfo>
                        <h6> Criticité : </h6>
                        {displayCriticality(criticality)}
                    </ContainerInfo>
                    <Deadline>
                        <h6> Échéance : </h6>
                        {displayDate()}
                    </Deadline>
                    <ProgressBar>
                        <h6> Avancement : </h6>
                        {LinearProgressBar(advancement)}
                    </ProgressBar>


                    {tags.length > 0 &&
                        <TagSection>
                            <div className={"wrapper"}>
                                {tags.map(tag => (
                                    <SubTagPlentyCard
                                        key={tag.id + "/" + tag.name}
                                        color={tag.color}
                                        id={tag.id}
                                        category={tag.category}
                                        name={tag.name}
                                        className={"no-hover"}
                                    />
                                ))}
                            </div>
                        </TagSection>
                    }
                </DIV>
            </Card>
            {
                !fromProject &&
                <ButtonsContainer>
                    <DisplayForHead
                        hasException={(pilot.id === currentUser.id) || (project.pilot.id === currentUser.id) || (project.copilot ? project.copilot.id === currentUser.id : false) || (project.axisSponsor ? project.axisSponsor.id === currentUser.id : false)}
                        component={
                            <EditButton
                                setUpdate={updateAction}
                                data={actionId}
                            />
                        }
                    />
                    <DisplayForHead
                        hasException={(project.pilot.id === currentUser.id) || (project.copilot ? project.copilot.id === currentUser.id : false) || (project.axisSponsor ? project.axisSponsor.id === currentUser.id : false)}
                        component={
                            <DeleteButton
                                setOpenDeleteModal={setIsOpenDeleteModal}
                            />
                        }
                    />

                </ButtonsContainer>
            }


        </Container>
    )
}
const Icon = styled.div`
  display: flex;
  justify-content: center;
  gap: 0.5rem;

  p {
    align-items: center;
    margin-top: 5px;
  }

  img {
    width: 2em;
    height: 2em;
    object-fit: cover;
    border-radius: 50%;
  }

`

const TopSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;


  @media (min-width: 800px) {
    flex-direction: row;
    align-items: center;
  }

`

const MiddleSection = styled.div`
  margin-left: 35px;
  display: flex;
  justify-content: start;
  gap: 0.5rem;
  width: 30%;
`
const TitleActionPage = styled.div`
  display: flex;
  align-items: center;
  width: 50%;


  p {
    text-align: center;
    font-size: 15px;
    font-weight: 700;

  }
`
const Title = styled.div`
  display: flex;
  align-items: center;
  text-align: center;

  p {
    font-size: 15px;
    font-weight: 700;
  }
`


const Pilot = styled.div`
  display: flex;
  justify-content: center;
  gap: 0.5rem;

  p {
    align-items: center;
    margin-top: 5px;
  }

  .icon-pilot {
    width: 2em;
    height: 2em;
    object-fit: cover;
    border-radius: 50%;
  }
`
const DIV = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-around;
  gap: 0.3rem;
  width: 100%;


  @media (min-width: 768px) {
    flex-direction: row;
  }
`
const Container = styled.div`
  display: flex;
  flex-direction: column-reverse;
  width: 100%;

  @media (min-width: 768px) {
    flex-direction: row;
  }
`

const TagSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
  padding: 0 1rem;
  width: 100%;

  .wrapper {
    display: flex;
    flex-direction: row;
    overflow-x: auto;
    margin: 0 0.5em;
    width: 100%;
    gap: 0.5rem;
  }
`

const ContainerInfo = styled.div`
  display: flex;
  align-items: baseline;
  white-space: break-spaces;
  overflow: hidden;
  padding-bottom: 0.5rem;
  gap: 0.5rem;

  h6 {
    white-space: nowrap;
  }

  @media (min-width: 800px) {
    padding-bottom: 0;
  }
`

const ContainerCriticality = styled.div`
  display: flex;
  flex-direction: row;
  justify-items: center;
  align-items: center;

`
const Card = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  box-shadow: rgba(0, 0, 0, 0.12) 0 6px 16px;
  padding: 0.5rem 0.5rem 1rem 0.5rem;
  border-radius: 15px;
  background: var(--color-white);
  align-items: center;
  gap: 0.3rem;

`
const ButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  @media (min-width: 800px) {
    flex-direction: column;
    justify-content: flex-start;

  }
`

const ProgressBar = styled(ContainerInfo)`
  .advancement-div {
    display: flex;
    flex-direction: row-reverse;
    align-items: inherit;

    p {
      padding-top: 0;
      padding-left: 0.2em;
      font-size: 12px;
    }

    .progress-container {
      height: 0.6rem;
      width: 9rem;
      border-radius: 0.4rem;
      background: rgba(204, 204, 204, 0.5);
    }

    .progress {
      height: 100%;
      width: 0;
      border-radius: 0.4rem;
      background: var(--color-red);
      transition: width 0.4s ease;
    }
  }

`
const Deadline = styled(ContainerInfo)`
  padding-right: 0.5em
`


export default ActionCard;